exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loader[data-v-8a153512] {\n  text-align: center;\n  margin-top: 20px;\n  margin-bottom:20px;\n}\n", "", {"version":3,"sources":["/home/benji/workspace-perso/onestore.io/www-app-vue/src/components/common/src/components/common/Loader.vue"],"names":[],"mappings":";AAaA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;CACA","file":"Loader.vue","sourcesContent":["<template>\n\t<div class=\"loader\">\n\t\t<i class=\"onestore-theme-secondary fa fa-cog fa-spin fa-2x\"></i>\n\t</div>\n</template>\n\n<script>\nexport default {\n  name: \"loader\"\n};\n</script>\n\n<style scoped>\n.loader {\n  text-align: center;\n  margin-top: 20px;\n  margin-bottom:20px;\n}\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8a153512","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Loader.vue
// module id = kK30
// module chunks = 1